<template>
  <OmtStickedModal v-if="isOpen" @close="$emit('update:isOpen', false)">
    <OmtTypography as="h1-bold" mb="8px" line-height="32px">
      Agende uma consulta com sua equipe de saúde Omint!
    </OmtTypography>
    <OmtTypography as="p1" line-height="22px" mb="32px"
      >Agende uma consulta e receba orientações e indicações de especialistas para a sua necessidade.</OmtTypography
    >
    <OmtButton w="100%" mb="16px" @click="solicitarAgendamento()">
      <OmtTypography as="button-large" color="white"> Agendar consulta </OmtTypography>
    </OmtButton>
    <OmtButton
      w="100%"
      variant="ghost"
      color="var(--colors-light-primary-navy-blue)"
      mb="34px"
      @click="solicitarIndicacao()"
    >
      <OmtTypography as="button-large" color="var(--colors-light-primary-navy-blue)">
        Solicitar indicação médica</OmtTypography
      >
    </OmtButton>
  </OmtStickedModal>
</template>

<script>
export default {
  props: {
    isOpen: {
      Type: Boolean
    }
  },
  methods: {
    solicitarIndicacao() {
      this.$router.push({
        path: "/indicacao-de-credenciados/criar-indicacao"
      });
    },
    solicitarAgendamento() {
      this.$router.push({
        path: "/agendamento/indicacao"
      });
    }
  }
};
</script>
